import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthService from "@/services/auth-service";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Welcome',
        component: () => import('../views/Welcome.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/signin',
        name: 'Sign In',
        component: () => import('../views/Signin.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/configuration/stripe-conf',
        name: 'StripeConfig',
        component: () => import('../views/configuration/StripeConfig.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-edit/:id/:stripeName/:privateKey/:apiKey/:endpointSecret/:checkoutDomain/:customerPortalLink/:application/:percentage/:active/:status',
        name: "StripeEdit",
        component: () => import('../views/configuration/StripeEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-edit',
        name: "StripeCreate",
        component: () => import('../views/configuration/StripeEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/payment-management',
        name: 'PaymentManagement',
        component: () => import('../views/configuration/PaymentManagement.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plans',
        name: 'Plans',
        component: () => import('../views/configuration/Plans.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plan-edit/:planId/:planName/:description/:duration/:orderNumber/:price/:maxDevices/:application/:active/:status/:trial',
        name: "PlanEdit",
        component: () => import('../views/configuration/PlanEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plan-edit',
        name: "PlanCreate",
        component: () => import('../views/configuration/PlanEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-plans',
        name: 'StripePlans',
        component: () => import('../views/configuration/StripePlans.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-plan-edit/:stripePlanId/:stripeConfigurationId/:planId/:stripeProductId/:stripePriceId/',
        name: "StripePlanEdit",
        component: () => import('../views/configuration/StripePlanEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-plan-edit',
        name: "StripePlanCreate",
        component: () => import('../views/configuration/StripePlanEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/coupons',
        name: 'Coupons',
        component: () => import('../views/configuration/Coupons.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/coupon-edit/:couponId/:couponCode/:percentage/:active/:status',
        name: "CouponEdit",
        component: () => import('../views/configuration/CouponEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/coupon-edit',
        name: "CouponCreate",
        component: () => import('../views/configuration/CouponEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-coupons',
        name: 'StripeCoupons',
        component: () => import('../views/configuration/StripeCoupons.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-coupon-edit/:stripeCouponId/:stripeConfigurationId/:stripeCouponCode/:couponId',
        name: "StripeCouponEdit",
        component: () => import('../views/configuration/StripeCouponEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/stripe-coupon-edit',
        name: "StripeCouponCreate",
        component: () => import('../views/configuration/StripeCouponEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/leagues',
        name: 'Leagues',
        component: () => import('../views/configuration/Leagues.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/league-edit/:leagueId/:caption/:description?/:logoFilename?/:logoAltText?/:application/:status/:active',
        name: "LeagueEdit",
        component: () => import('../views/configuration/LeagueEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/league-edit',
        name: "LeagueCreate",
        component: () => import('../views/configuration/LeagueEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/cal-leagues',
        name: 'CalLeagues',
        component: () => import('../views/configuration/CalLeagues.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/cal-league-edit/:calLeagueId/:name/:shortName/:sport?/:uid?/:lastImport?/:status/:active/:calendarSourceUrl?',
        name: "CalLeagueEdit",
        component: () => import('../views/configuration/CalLeagueEdit.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/cal-league/:calLeagueId/matches/:name/:shortName?/:sport?/:uid?/:lastImport?/:status?/:active?/:calendarSourceUrl?',
        name: "CalLeagueMatches",
        component: () => import('../views/configuration/CalMatches.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/cal-matches',
        name: "CalMatchesAll",
        component: () => import('../views/configuration/AllMatches.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/cal-match-edit/:calMatchId',
        name: "CalMatchEdit",
        component: () => import('../views/configuration/CalMatchEdit.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/cal-league/:calLeagueId/match-events/:name/:shortName?/:sport?/:uid?/:lastImport?/:status?/:active?/:calendarSourceUrl?',
        name: "CalLeagueMatchEvents",
        component: () => import('../views/configuration/MatchEvents.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        // Merged into All Matches - kept as a redirect so old links/bookmarks still work.
        path: '/configuration/match-events',
        name: "MatchEventsAll",
        redirect: { name: 'CalMatchesAll' }
    },
    {
        path: '/configuration/cal-league-edit',
        name: "CalLeagueCreate",
        component: () => import('../views/configuration/CalLeagueEdit.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/daily',
        name: 'Daily',
        component: () => import('../views/configuration/Daily.vue'),
        meta: {
            requiresAuth: true,
            // Calendar page - the header's App selector is hidden here.
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/week',
        name: 'WeekCalendar',
        component: () => import('../views/configuration/WeekCalendar.vue'),
        meta: {
            requiresAuth: true,
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/live-events',
        name: 'LiveEvents',
        component: () => import('../views/configuration/LiveEvents.vue'),
        meta: {
            requiresAuth: true,
            hideAppSelector: true
        }
    },
    {
        path: '/configuration/events',
        name: 'Events',
        component: () => import('../views/configuration/Events.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/events-list',
        name: 'EventsList',
        component: () => import('../views/configuration/EventsList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/event-edit/:eventId/:firstMatcher/:secondMatcher/:league/:leagueId?/:orderNumber/:application?/:status/:active',
        name: "EventEdit",
        component: () => import('../views/configuration/EventEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/event-edit',
        name: "EventCreate",
        component: () => import('../views/configuration/EventEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/event-broadcast/:eventId/:firstMatcher/:secondMatcher/:league/:leagueId?/:orderNumber/:application?/:status/:active',
        name: 'EventBroadcast',
        component: () => import('@/views/configuration/EventBroadcast.vue')
    },
    {
        path: '/configuration/channels',
        name: 'Channels',
        component: () => import('../views/configuration/Channels.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        // Only the id travels in the URL; the page loads the channel itself. ?app= is the application whose events are offered.
        path: '/configuration/channel-edit/:channelId(\\d+)',
        name: "ChannelEdit",
        component: () => import('../views/configuration/ChannelEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/channel-broadcast/:channelId/:channelName/:eventIds*/:caption/:protectKey/:tags?/:appName/:edgePort/:liveViews/:totalViews/:orderNumber?/:status/:active',
        name: "ChannelBroadcast",
        component: () => import('../views/configuration/ChannelBroadcast.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/channel-edit',
        name: "ChannelCreate",
        component: () => import('../views/configuration/ChannelEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/cdn-regions',
        name: 'CDNRegions',
        component: () => import('../views/configuration/CDNRegions.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/cdn-region-edit/:cdnRegionKey/:cdnRegionValue/:active/:application',
        name: "CDNRegionEdit",
        component: () => import('../views/configuration/CDNRegionEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/cdn-region-edit',
        name: "CDNRegionCreate",
        component: () => import('../views/configuration/CDNRegionEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/regions',
        name: 'Regions',
        component: () => import('../views/configuration/Regions.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/region-edit/:countryIsoCode/:region',
        name: "RegionEdit",
        component: () => import('../views/configuration/RegionEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/region-edit',
        name: "RegionCreate",
        component: () => import('../views/configuration/RegionEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/video-qualities',
        name: 'VideoQualities',
        component: () => import('../views/configuration/VideoQualities.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/video-quality-edit/:videoQualityKey/:videoQualityValue?/:active/:application',
        name: "VideoQualityEdit",
        component: () => import('../views/configuration/VideoQualityEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/video-quality-edit',
        name: "VideoQualityCreate",
        component: () => import('../views/configuration/VideoQualityEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/applications',
        name: 'Applications',
        component: () => import('../views/configuration/Applications.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/application-edit/:application/:domains?/:description?/:hlsPrefix?/:hlsSufix?/:edgePort/:appName/:vidictLicense/:vidictSecret/:active/:sport?',
        name: "ApplicationEdit",
        component: () => import('../views/configuration/ApplicationEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/configuration/system',
        name: 'System',
        component: () => import('../views/configuration/System.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/system-edit/:name/:value?/:application',
        name: "SystemEdit",
        component: () => import('../views/configuration/SystemEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/system-edit',
        name: "SystemCreate",
        component: () => import('../views/configuration/SystemEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/paypal-conf',
        name: 'PaypalConfig',
        component: () => import('../views/configuration/PaypalConfig.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/paypal-edit/:id/:paypalName/:brandName/:clientId/:clientSecret/:webhookId/:apiBase/:redirectUrl/:application/:percentage/:active/:status',
        name: "PaypalEdit",
        component: () => import('../views/configuration/PaypalEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/paypal-edit',
        name: "PaypalCreate",
        component: () => import('../views/configuration/PaypalEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plisio-conf',
        name: 'PlisioConfig',
        component: () => import('../views/configuration/PlisioConfig.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plisio-edit/:id/:plisioName/:apiKey/:redirectUrl/:callbackUrl/:failInvoiceUrl/:application/:active/:status',
        name: "PlisioEdit",
        component: () => import('../views/configuration/PlisioEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/plisio-edit',
        name: "PlisioCreate",
        component: () => import('../views/configuration/PlisioEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/square-conf',
        name: 'SquareConfig',
        component: () => import('../views/configuration/SquareConfig.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/square-edit/:id/:squareName/:accessToken/:locationId/:webhookSignatureKey/:webhookUrl/:redirectUrl/:apiBase/:application/:percentage/:active/:status',
        name: "SquareEdit",
        component: () => import('../views/configuration/SquareEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/square-edit',
        name: "SquareCreate",
        component: () => import('../views/configuration/SquareEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/cpay-conf',
        name: 'CpayConfig',
        component: () => import('../views/configuration/CpayConfig.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/configuration/cpay-edit/:id/:cpayName/:secret/:checkoutPage/:paymentGateway/:application/:percentage/:whatsappEnabled/:active/:status',
        name: "CpayEdit",
        component: () => import('../views/configuration/CpayEdit.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        }
    },
    {
        path: '/users',
        name: 'Users',
        component: () => import('../views/user/Users.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/:userId/:email/:loginId/:emailSubscribe/:role/:region?/:videoQuality?/:active/:status/:emailCleanStatus?',
        name: "UserEdit",
        component: () => import('../views/user/UserEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/:email',
        name: "UserProfile",
        component: () => import('../views/user/UserProfile.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/stripe-users',
        name: 'StripeUsers',
        component: () => import('../views/user/StripeUsers.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/stripe-users',
        name: "StripeUserCreate",
        component: () => import('../views/user/StripeUserEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/stripe-users/:stripeUserId/:stripeConfigurationId/:userId/:stripeCustomerId',
        name: "StripeUserEdit",
        component: () => import('../views/user/StripeUserEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/user-plan',
        name: 'UserPlans',
        component: () => import('../views/user/UserPlans.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/user-plan',
        name: "UserPlanCreate",
        component: () => import('../views/user/UserPlanEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/user-plan/:userPlanId/:userId/:planId/:couponCode?/:startDate/:endDate/:trialActivationCode?/:stripeInvoice?/:stripeConfigurationId?/:paypalConfigurationId?/:paypalOrderId?/:paypalCaptureId?/:plisioConfigurationId?/:plisioTxnId?/:squareConfigurationId?/:squareOrderId?/:cpayPayment?/:stripePaidAmount?/:stripePaymentDate?/:created?/:updated?/:active/:status',
        name: "UserPlanEdit",
        component: () => import('../views/user/UserPlanEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/sessions',
        name: 'Sessions',
        component: () => import('../views/user/Sessions.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users/sessions/:sessionId/:userId/:region?/:edgeAddress/:protocol/:channelId/:channelName/:vidictId?/:deviceOs?/:deviceType?/:appVersion?/:application?/:userAgent?/:randomUUID/:startTime/:endTime?',
        name: "SessionEdit",
        component: () => import('../views/user/SessionEdit.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/analytics/:id',
        name: 'Analytics Report',
        component: () => import('../views/Analytics.vue'),
        meta: {
            requiresAuth: true,
            pageName: 'Analytics'
        }
    },
    {
        // Must come before /finance/:id - otherwise Vue Router matches "ai-report" as :id first.
        path: '/finance/ai-report',
        name: 'AI Financial Report',
        component: () => import('../views/AiReport.vue'),
        meta: {
            requiresAuth: true,
            requiresAdmin: true,
            pageName: 'Finance'
        }
    },
    {
        path: '/finance/:id',
        name: 'Finance Report',
        component: () => import('../views/Analytics.vue'),
        meta: {
            requiresAuth: true,
            pageName: 'Finance'
        }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0,0);
    if (to.meta.requiresAuth) {
        if (!AuthService.isSignedIn()) {
            return next('/signin')
        }
    }

    if (to.meta.requiresAdmin && !AuthService.isAdmin()) {
        return next('/')
    }

    next()
})

export default router
